<!-- =========================================================================================
    File Name: ForgotPassword.vue
    Description: FOrgot Password Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
    <div class="h-screen flex w-full bg-img">
        <div class="vx-col w-4/5 sm:w-4/5 md:w-3/5 lg:w-3/4 xl:w-3/5 mx-auto self-center">
            <vx-card>
                <div slot="no-body" class="full-page-bg-color">
                    <div class="vx-row">
                        <div class="vx-col hidden sm:hidden md:hidden lg:block lg:w-1/2 mx-auto self-center">
                            <img src="@/assets/images/pages/forgot-password.png" alt="login" class="mx-auto">
                        </div>
                        <div class="vx-col sm:w-full md:w-full lg:w-1/2 mx-auto self-center d-theme-dark-bg">
                            <div class="p-8">
                                <div class="vx-card__title mb-8">
                                    <h4 class="mb-4">Recover your password</h4>
                                    <p>Please enter your email address and we'll send you instructions on how to reset your password.</p>
                                </div>

                                <vs-input type="email" label-placeholder="Email" name="email" v-model="email" class="w-full mb-8"  v-validate="'required|email'" />
                                
                                <span class="text-danger text-sm">{{ errors.first('email') }}</span>
                                <span class="text-danger text-sm">{{ this.message }}</span><br>
                                <vs-button type="border" to="/pages/login" class="px-4 w-full md:w-auto">Back To Login</vs-button>
                                <vs-button class="float-right px-4 w-full md:w-auto mt-3 mb-8 md:mt-0 md:mb-0" :disabled="!validateForm" @click.prevent="recover()">Recover Password</vs-button>
                            </div>
                        </div>
                    </div>
                </div>
            </vx-card>
        </div>
    </div>
</template>

<script>
import * as firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'
export default {
  
    data() {
        return {
            email: '',
            message:''
        }
    },
     computed: {
        validateForm() {
            return !this.errors.any() && this.email != '';
        },
    },
    methods:{
        recover(){
            var auth = firebase.auth();
            if(this.email!=null){

            
            auth.sendPasswordResetEmail(this.email).then(()=> {
            // Email sent.
            this.notifysuccess();
             this.message ='Please Check your mail to recover your password';
           
            }).catch(err => {
                
                this.message ='There is no user record corresponding to this Email Address';
                this.notify(err.message)
            });
            
                    }
                   
        },
        notify(message){
            this.$vs.notify({
                title: 'Recover Password',
                text: message,
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'warning',
                time:2000
            });
        },
        notifysuccess() {
             this.$vs.notify({color:'success',title:'Request Submitted Successfully',text:'Please Check your mail to recover your password', time:6000})
        }
    }
}
</script>

